import { render } from "./QuickLinksMenu.vue?vue&type=template&id=5d280e71"
import script from "./QuickLinksMenu.vue?vue&type=script&lang=js"
export * from "./QuickLinksMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__